"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isTokenExpired = void 0;
const decode_jwt_1 = require("./decode-jwt");
const isTokenExpired = (token) => {
    try {
        const tokenContent = (0, decode_jwt_1.decodeJwt)(token);
        const tokenExpiration = tokenContent.exp || 0;
        return tokenExpiration * 1000 - Date.now() <= 0;
    }
    catch {
        return true; // Treat invalid tokens as expired
    }
};
exports.isTokenExpired = isTokenExpired;
//# sourceMappingURL=is-token-expired.js.map